const addFiltersCapabilities = requestHandler => (type, resource, params) => {
    if (params.filter){
        if ( params != null && params.filter.name != null && resource == 'news' ) {
            params.filter = { name: { regexp: `.*${params.filter.name}.*` } };
        }else if (params != null && params.filter.title != null && (resource == 'sliders' ||  resource == 'faqs' || resource == 'pqrs' || resource == 'pages' || resource == 'SubPages'  )){
            params.filter = { title: { regexp: `.*${params.filter.title}.*` } };
        }else if (params != null && params.filter.user != null && (resource == 'Carts'  )){
            params.filter = { user: { regexp: `.*${params.filter.user}.*` } };
        }
    }else{
    }
    return requestHandler(type, resource, params);
};

export default addFiltersCapabilities;
